var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5034 22.0005C10.0972 22.0005 8.69092 22.0075 7.28467 21.9935C6.93311 21.9935 6.58155 21.9653 6.24405 21.888C4.97139 21.5856 4.12061 20.6646 4.02921 19.3146C3.91671 17.6763 4.11358 16.0591 4.89405 14.5755C5.49874 13.4294 6.43389 12.7614 7.74874 12.7263C8.02999 12.7192 8.33936 12.8388 8.59952 12.9724C9.1128 13.2255 9.58389 13.57 10.1042 13.788C11.3417 14.3153 12.53 14.0974 13.662 13.4364C13.8308 13.338 14.0136 13.2396 14.1612 13.113C14.7519 12.6208 15.3987 12.6419 16.0808 12.8458C17.023 13.1271 17.6839 13.7458 18.1269 14.6036C18.9214 16.1505 19.1183 17.8239 18.9495 19.5255C18.8089 20.9669 17.5644 21.9794 15.9964 22.0005C14.5058 22.0146 13.0011 22.0005 11.5034 22.0005Z",
    fill: "#848FAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05953 8.28298C7.10172 5.82907 9.04938 3.95173 11.4963 4.00095C13.8588 4.05016 15.7713 6.03298 15.722 8.40251C15.6728 10.8283 13.7111 12.7127 11.2923 12.6634C8.90172 12.6142 7.01031 10.6595 7.05953 8.28298Z",
    fill: "#848FAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserItem);
export default __webpack_public_path__ + "static/media/userItem.e3bc63bb5c705d218f23cce439535925.svg";
export { ForwardRef as ReactComponent };